import script from "./detail-dialog-header.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-dialog-header.vue?vue&type=script&setup=true&lang=js"

import "./detail-dialog-header.vue?vue&type=style&index=0&id=4849df06&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4849df06"]])

export default __exports__